module.exports = __webpack_public_path__ + "static/profile-zora-zamecnikova-4925d95e4659b56e7e2bfd70dee155b1.png";